module.exports = __webpack_public_path__ + "assets/img/portfolio-pirmas-2x.a0602da5.jpg";